import { render, staticRenderFns } from "./ReportDeal.vue?vue&type=template&id=2d143ef0&"
import script from "./ReportDeal.vue?vue&type=script&lang=js&"
export * from "./ReportDeal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports